import { FinanceDocument } from './FinanceDocument';
import { FinanceWithdrawal } from './FinanceWithdrawal';
import { FinanceHistory } from './FinanceHistory';

export interface FinanceDeposit {
  id: number;
  type: 'deposit' | 'withdrawal'
  concept: string;
  conceptMonth: string;
  conceptNumber: string;
  amount: number;
  amountFee: number;
  accountId: number | null;
  account: FinanceDepositAccountOption | null;
  creditId: number | null;
  credit: FinanceDepositCreditOption | null;
  code: string | null;
  codePlusFee?: string | null;
  creditCode: string | null;
  paymentDate: string;
  purpose: string;
  details: string | null;
  accredited: string | null;
  received: boolean;
  createdAt: string;
  updatedAt: string;
  receipts: FinanceDocument[];
  invoices: FinanceDocument[];
  airtableId: string | null;
  adminId: number | null;
  adminName: string | null;
  fee: boolean;
  feePercent: number;
  history: FinanceHistory[];
  isUsd?: boolean;
  exchangeRate?: number;
  amountUsd?: number;
}

export type FinanceTransaction = FinanceDeposit | FinanceWithdrawal;

export interface FinanceDepositAccountOption {
  id: number;
  code: string;
  account: string;
  balance?: number;
}

export interface FinanceDepositCreditOption {
  id: number;
  code: string;
  accredited: string;
  balanceTitle?: string;
  balance?: number;
  hasFinanceAccount?: boolean;
}

export interface FinanceDepositOptions {
  concept: string[];
  conceptMonth: string;
  conceptNumber: string;
  purpose: string[];
  accounts: FinanceDepositAccountOption[];
  credits: FinanceDepositCreditOption[];
}

export interface CreateFinanceDepositParams {
  concept: string;
  amount: number;
  accountId: number | null;
  creditId: number | null;
  paymentDate: string;
  purpose: string;
  details: string | null;
  received: boolean;
  isUsd?: boolean;
  exchangeRate?: number;
  amountUsd?: number;
}

export const purposeOptions = ['Credits', 'Operations'].map(opt => ({
  id: opt,
  name: opt,
}));
